import axios from 'axios'

export function setHeader () {
    axios.defaults.headers.common = {
        'token': localStorage.getItem('token'),
        'Accept': 'application/json',
    }
}

setHeader()

export function NetworkCommunicator (method, url, loading, postData) {
    if (method === 'GET') {
        return axios.get(url).then(response => {
            return response.data
        })
    } else if (method === 'POST') {
        return axios.post(url, postData).then(response => {
            return response.data
        })
    } else if (method === 'PUT') {
        return axios.put(url, postData).then(response => {
            return response.data
        })
    }
}

export default { NetworkCommunicator, setHeader }